import {
  REQUEST as req, RESPONSE as res, FAILURE as fail,
  PROGRESS as prog, CLEAR as clr,
} from '../../actions/foundation/byomUpload';

const initialState = {
  response: null,   // { model_id, model_uri, size_bytes, ext, ... }
  progress: 0,
  isLoading: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case req:  return { ...initialState, isLoading: true };
    case prog: return { ...state, progress: action.payload };
    case res:  return { ...state, isLoading: false, progress: 100, response: action.payload };
    case fail: return { ...state, isLoading: false, error: action.payload };
    case clr:  return initialState;
    default:   return state;
  }
};
